import {useEffect, useSyncExternalStore} from "react";
import {formsApi} from "./forms-api";

// May this workspace use «Smart forms»? Decided on the server (plan Business / Enterprise, the first free trial);
// one request per workspace shared by the sidebar and the pages. Unknown / failed = hidden, never shown by mistake.
let snapshot = {workspace: null, access: null};
const listeners = new Set();
const inflight = new Map();

const emit = (next) => {
    snapshot = next;
    listeners.forEach((listener) => listener());
};

export function refreshFormsAccess(workspace) {
    if (!workspace) return Promise.resolve(null);
    if (inflight.has(workspace)) return inflight.get(workspace);
    if (snapshot.workspace !== workspace) emit({workspace, access: null});
    const request = formsApi.access()
        .then((access) => access || {allowed: false})
        .catch(() => ({allowed: false, failed: true}))
        .then((access) => {
            if (snapshot.workspace === workspace) emit({workspace, access});
            return access;
        })
        .finally(() => inflight.delete(workspace));
    inflight.set(workspace, request);
    return request;
}

export function useFormsAccess(workspace) {
    const state = useSyncExternalStore((listener) => {
        listeners.add(listener);
        return () => listeners.delete(listener);
    }, () => snapshot);
    useEffect(() => {
        if (workspace && (snapshot.workspace !== workspace || !snapshot.access)) refreshFormsAccess(workspace);
    }, [workspace]);
    return state.workspace === workspace ? state.access : null;
}

// tests only
export function resetFormsAccess() {
    snapshot = {workspace: null, access: null};
    inflight.clear();
}
